import * as React from 'react';
import { CFCardSerialValidator } from '../../../forms/validation/CFCardSerialValidator';
import Alert, { AlertCategoryEnum } from '../../../misc/components/Alert';

interface CardSerialProps {
    value?: string;
    showError: boolean;
    error: string;
    onChange: (value: string) => void;
    onNext?: (value: string, isValid?: boolean, validationMessage?: string) => void;
    onBack: () => void;
}

export const CardSerial = ({ value, showError, error, onChange, onNext, onBack }: CardSerialProps) => {
    const validate = (value: string) => {
        if (onNext && CFCardSerialValidator(value)) onNext(value, false, 'Invalid card serial number');
        else if (onNext) onNext(value, true);
    }

    const handleChange = (event) => {
        const value = event.target.value;
        onChange(value);
    }

    const handleNext = () => {
        validate(value)
    }

    return (
        <>
            <div className="modal-body">
                <Alert show={showError} category={AlertCategoryEnum.Danger}>
                    {error}
                </Alert>
                <h2
                    className="text-primary">Card Details</h2>
                <p
                    style={{ marginBottom: '15px' }}
                    className="text-muted">Enter or scan the card serial number</p>
                <div
                    className="row">
                    <div
                        className="col-sm-6">
                        <div
                            className="input-group">
                            <span
                                className="input-group-addon">FF</span>
                            <input
                                className="form-control"
                                type="number"
                                placeholder="#####"
                                autoFocus={true}
                                pattern="\d{4,5}"
                                value={value}
                                onChange={handleChange} />
                        </div>
                    </div>
                    <div className="col-sm-6"></div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={() => handleNext()}>Next</button>
                <button className="btn btn-primary btn-outline" onClick={() => onBack()}>Back</button>
            </div>
        </>
    );
}
